// Resume Files
import CV_RIDWAN_PDF from './CV_ATS_RIDWAN.pdf';
import CV_RIDWAN_WORD from './CV_ATS_RIDWAN.docx';
import CV_RIDWAN_IMAGE from './CV_ATS_RIDWAN.jpg';

// Home Page Images
import HOME_PROFILE from './images/home_portfolio_profile.webp';
import FUENZER_APPS from './images/fuenzer_apps_logo.webp';
import FUENZER_STUDIO from './images/fuenzer_studio_logo.webp';

// Profile & Education Images
import DEVELOPER_PROFILE from './images/profile_developer.webp';
import SMAN9_LOGO from './images/sman_9_semarang_logo.webp';
import UNNES_LOGO from './images/unnes_logo.webp';

// Profile Dashboard Logos
import MICROSOFT_FABRIC_LOGO from './svg/microsoft_fabric_2023.svg';
import COGNITIVE_CLASS_LOGO from './svg/cognitive_class_logo.svg';
import DICODING_LOGO from './svg/dicoding_logo.svg';

// Carousel Logos
import DICODING_HEADER_LOGO from './images/dicoding_header_logo.png';
import AWS_LOGO from './images/aws_logo.png';
import CISCO_LOGO from './images/cisco_logo.png';
import COURSERA_LOGO from './images/coursera_logo.png';
import EDX_LOGO from './images/edx_logo.png';
import GITHUB_LOGO from './images/github_logo.png';
import GOOGLE_CLOUD_LOGO from './images/google_cloud_logo.png';
import HACKERRANK_LOGO from './images/hackerrank_logo.png';
import HP_LIFE_LOGO from './images/hp_life_logo.png';
import IBM_LOGO from './images/ibm_logo.png';
import JETBRAINS_ACADEMY_LOGO from './images/jetbrains_academy_logo.png';
import KAGGLE_LOGO from './images/kaggle_logo.png';
import MICROSOFT_LOGO from './images/microsoft_logo.png';
import MIMO_LOGO from './images/mimo_logo.png';
import NVIDIA_LOGO from './images/nvidia_logo.png';
import SOLOLEARN_LOGO from './images/sololearn_logo.png';

export const RESUME_ASSETS = {
    resumepdf: CV_RIDWAN_PDF,
    resumeword: CV_RIDWAN_WORD,
    resumeimage: CV_RIDWAN_IMAGE,
}

export const HOME_ASSETS = {
    homeprofile: HOME_PROFILE,
    fuenzerapps: FUENZER_APPS,
    fuenzerstudio: FUENZER_STUDIO,
}

export const ABOUT_ASSETS = {
    developerprofile: DEVELOPER_PROFILE,
    sman9logo: SMAN9_LOGO,
    unneslogo: UNNES_LOGO,
    microsoftfabriclogo: MICROSOFT_FABRIC_LOGO,
    cognitiveclasslogo: COGNITIVE_CLASS_LOGO,
    dicodinglogo: DICODING_LOGO,
}

export const CAROUSEL_ASSETS = {
    dicodingheaderlogo: DICODING_HEADER_LOGO,
    awslogo: AWS_LOGO,
    ciscologo: CISCO_LOGO,
    courseralogo: COURSERA_LOGO,
    edxlogo: EDX_LOGO,
    githublogo: GITHUB_LOGO,
    googlecloudlogo: GOOGLE_CLOUD_LOGO,
    hackerranklogo: HACKERRANK_LOGO,
    hplifelogo: HP_LIFE_LOGO,
    ibmlogo: IBM_LOGO,
    jetbrainsacademylogo: JETBRAINS_ACADEMY_LOGO,
    kagglelogo: KAGGLE_LOGO,
    microsoftlogo: MICROSOFT_LOGO,
    mimologo: MIMO_LOGO,
    nvidialogo: NVIDIA_LOGO,
    sololearnlogo: SOLOLEARN_LOGO,
}